@import "@/ui/variables.css";

.textFieldRoot {
  --icon-size: 16px;
  display: flex;
  align-items: center;

  input {
    background-color: var(--gray-light);
    border-radius: var(--radius);
    border: none;
    color: var(--white);
    font-family: var(--font);
    font-size: 0.9rem;
    padding: var(--space-1) var(--space-2);
    width: 100%;
  }

  input::placeholder {
    color: var(--gray-lightest);
  }

  svg {
    position: absolute;
    width: var(--icon-size);
    height: var(--icon-size);
    transform: translateX(calc(var(--icon-size)));
    color: var(--white);
  }

  svg + input {
    padding-left: calc(var(--space-2) + var(--icon-size) * 2);
  }

  &[data-variant="soft"] {
    input {
      background-color: oklch(from var(--gray-light) calc(l + 0.6) c h);
      border: 1px solid var(--gray-lighter);
      color: var(--gray-dark);
    }
  }
}
